var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf-paginator"},[(_vm.pageCount)?[_c('input',{attrs:{"min":"1","max":_vm.pageCount,"type":"number"},domProps:{"value":_vm.value},on:{"input":_vm.input}}),_vm._v(" / "),_c('span',[_vm._v(_vm._s(_vm.pageCount))])]:_c('input',{attrs:{"readonly":"","type":"number"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6956a8d0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PDFPaginator.vue
// module id = null
// module chunks = 